// src/components/dropdown/Dropdown.js
import React, { useState } from 'react';

function Dropdown({ value, onChange, placeholder = 'Select an option' }) {
  const [isOpen, setIsOpen] = useState(false);
  
  const options = [
    'Owns more than 25% of the company',
    'Owns more than 50% of the company',
    'Owns more than 75% of the company'
  ];

  const handleSelectOption = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button 
        type="button"
        className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        {value || placeholder}
      </button>

      {isOpen && (
        <div className="absolute z-10 w-full bg-white shadow rounded mt-1">
          {options.map((option, index) => (
            <div 
              key={index} 
              className="px-4 py-2 cursor-pointer hover:bg-gray-100"
              onClick={() => handleSelectOption(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Dropdown;
